import { render } from "./HomeViewM2M.vue?vue&type=template&id=44f665ee&scoped=true"
import script from "./HomeViewM2M.vue?vue&type=script&lang=js"
export * from "./HomeViewM2M.vue?vue&type=script&lang=js"

import "./HomeViewM2M.vue?vue&type=style&index=0&id=44f665ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f665ee"]])

export default __exports__